const city = (name, type, province) => ({
    name,
    type,
    province,
});
export const INDONESIAN_CITIES = [
    city('Jakarta Pusat', 'Kota', 'DKI Jakarta'),
    city('Jakarta Selatan', 'Kota', 'DKI Jakarta'),
    city('Jakarta Barat', 'Kota', 'DKI Jakarta'),
    city('Jakarta Timur', 'Kota', 'DKI Jakarta'),
    city('Jakarta Utara', 'Kota', 'DKI Jakarta'),
    city('Kepulauan Seribu', 'Kabupaten', 'DKI Jakarta'),
    city('Bandung', 'Kota', 'Jawa Barat'),
    city('Bandung Barat', 'Kabupaten', 'Jawa Barat'),
    city('Bandung', 'Kabupaten', 'Jawa Barat'),
    city('Bekasi', 'Kota', 'Jawa Barat'),
    city('Bekasi', 'Kabupaten', 'Jawa Barat'),
    city('Bogor', 'Kota', 'Jawa Barat'),
    city('Bogor', 'Kabupaten', 'Jawa Barat'),
    city('Cimahi', 'Kota', 'Jawa Barat'),
    city('Cirebon', 'Kota', 'Jawa Barat'),
    city('Cirebon', 'Kabupaten', 'Jawa Barat'),
    city('Depok', 'Kota', 'Jawa Barat'),
    city('Sukabumi', 'Kota', 'Jawa Barat'),
    city('Sukabumi', 'Kabupaten', 'Jawa Barat'),
    city('Tasikmalaya', 'Kota', 'Jawa Barat'),
    city('Tasikmalaya', 'Kabupaten', 'Jawa Barat'),
    city('Banjar', 'Kota', 'Jawa Barat'),
    city('Ciamis', 'Kabupaten', 'Jawa Barat'),
    city('Cianjur', 'Kabupaten', 'Jawa Barat'),
    city('Garut', 'Kabupaten', 'Jawa Barat'),
    city('Indramayu', 'Kabupaten', 'Jawa Barat'),
    city('Karawang', 'Kabupaten', 'Jawa Barat'),
    city('Kuningan', 'Kabupaten', 'Jawa Barat'),
    city('Majalengka', 'Kabupaten', 'Jawa Barat'),
    city('Pangandaran', 'Kabupaten', 'Jawa Barat'),
    city('Purwakarta', 'Kabupaten', 'Jawa Barat'),
    city('Subang', 'Kabupaten', 'Jawa Barat'),
    city('Sumedang', 'Kabupaten', 'Jawa Barat'),
    city('Tangerang', 'Kota', 'Banten'),
    city('Tangerang Selatan', 'Kota', 'Banten'),
    city('Tangerang', 'Kabupaten', 'Banten'),
    city('Serang', 'Kota', 'Banten'),
    city('Serang', 'Kabupaten', 'Banten'),
    city('Cilegon', 'Kota', 'Banten'),
    city('Lebak', 'Kabupaten', 'Banten'),
    city('Pandeglang', 'Kabupaten', 'Banten'),
    city('Semarang', 'Kota', 'Jawa Tengah'),
    city('Semarang', 'Kabupaten', 'Jawa Tengah'),
    city('Surakarta (Solo)', 'Kota', 'Jawa Tengah'),
    city('Magelang', 'Kota', 'Jawa Tengah'),
    city('Magelang', 'Kabupaten', 'Jawa Tengah'),
    city('Pekalongan', 'Kota', 'Jawa Tengah'),
    city('Pekalongan', 'Kabupaten', 'Jawa Tengah'),
    city('Salatiga', 'Kota', 'Jawa Tengah'),
    city('Tegal', 'Kota', 'Jawa Tengah'),
    city('Tegal', 'Kabupaten', 'Jawa Tengah'),
    city('Banyumas (Purwokerto)', 'Kabupaten', 'Jawa Tengah'),
    city('Batang', 'Kabupaten', 'Jawa Tengah'),
    city('Blora', 'Kabupaten', 'Jawa Tengah'),
    city('Boyolali', 'Kabupaten', 'Jawa Tengah'),
    city('Brebes', 'Kabupaten', 'Jawa Tengah'),
    city('Cilacap', 'Kabupaten', 'Jawa Tengah'),
    city('Demak', 'Kabupaten', 'Jawa Tengah'),
    city('Grobogan', 'Kabupaten', 'Jawa Tengah'),
    city('Jepara', 'Kabupaten', 'Jawa Tengah'),
    city('Karanganyar', 'Kabupaten', 'Jawa Tengah'),
    city('Kebumen', 'Kabupaten', 'Jawa Tengah'),
    city('Kendal', 'Kabupaten', 'Jawa Tengah'),
    city('Klaten', 'Kabupaten', 'Jawa Tengah'),
    city('Kudus', 'Kabupaten', 'Jawa Tengah'),
    city('Pati', 'Kabupaten', 'Jawa Tengah'),
    city('Pemalang', 'Kabupaten', 'Jawa Tengah'),
    city('Purbalingga', 'Kabupaten', 'Jawa Tengah'),
    city('Purworejo', 'Kabupaten', 'Jawa Tengah'),
    city('Rembang', 'Kabupaten', 'Jawa Tengah'),
    city('Sragen', 'Kabupaten', 'Jawa Tengah'),
    city('Sukoharjo', 'Kabupaten', 'Jawa Tengah'),
    city('Temanggung', 'Kabupaten', 'Jawa Tengah'),
    city('Wonogiri', 'Kabupaten', 'Jawa Tengah'),
    city('Wonosobo', 'Kabupaten', 'Jawa Tengah'),
    city('Yogyakarta', 'Kota', 'DI Yogyakarta'),
    city('Bantul', 'Kabupaten', 'DI Yogyakarta'),
    city('Gunungkidul', 'Kabupaten', 'DI Yogyakarta'),
    city('Kulon Progo', 'Kabupaten', 'DI Yogyakarta'),
    city('Sleman', 'Kabupaten', 'DI Yogyakarta'),
    city('Surabaya', 'Kota', 'Jawa Timur'),
    city('Malang', 'Kota', 'Jawa Timur'),
    city('Malang', 'Kabupaten', 'Jawa Timur'),
    city('Batu', 'Kota', 'Jawa Timur'),
    city('Blitar', 'Kota', 'Jawa Timur'),
    city('Blitar', 'Kabupaten', 'Jawa Timur'),
    city('Kediri', 'Kota', 'Jawa Timur'),
    city('Kediri', 'Kabupaten', 'Jawa Timur'),
    city('Madiun', 'Kota', 'Jawa Timur'),
    city('Madiun', 'Kabupaten', 'Jawa Timur'),
    city('Mojokerto', 'Kota', 'Jawa Timur'),
    city('Mojokerto', 'Kabupaten', 'Jawa Timur'),
    city('Pasuruan', 'Kota', 'Jawa Timur'),
    city('Pasuruan', 'Kabupaten', 'Jawa Timur'),
    city('Probolinggo', 'Kota', 'Jawa Timur'),
    city('Probolinggo', 'Kabupaten', 'Jawa Timur'),
    city('Banyuwangi', 'Kabupaten', 'Jawa Timur'),
    city('Bojonegoro', 'Kabupaten', 'Jawa Timur'),
    city('Bondowoso', 'Kabupaten', 'Jawa Timur'),
    city('Gresik', 'Kabupaten', 'Jawa Timur'),
    city('Jember', 'Kabupaten', 'Jawa Timur'),
    city('Jombang', 'Kabupaten', 'Jawa Timur'),
    city('Lamongan', 'Kabupaten', 'Jawa Timur'),
    city('Lumajang', 'Kabupaten', 'Jawa Timur'),
    city('Magetan', 'Kabupaten', 'Jawa Timur'),
    city('Nganjuk', 'Kabupaten', 'Jawa Timur'),
    city('Ngawi', 'Kabupaten', 'Jawa Timur'),
    city('Pacitan', 'Kabupaten', 'Jawa Timur'),
    city('Pamekasan', 'Kabupaten', 'Jawa Timur'),
    city('Ponorogo', 'Kabupaten', 'Jawa Timur'),
    city('Sampang', 'Kabupaten', 'Jawa Timur'),
    city('Sidoarjo', 'Kabupaten', 'Jawa Timur'),
    city('Situbondo', 'Kabupaten', 'Jawa Timur'),
    city('Sumenep', 'Kabupaten', 'Jawa Timur'),
    city('Trenggalek', 'Kabupaten', 'Jawa Timur'),
    city('Tuban', 'Kabupaten', 'Jawa Timur'),
    city('Tulungagung', 'Kabupaten', 'Jawa Timur'),
    city('Medan', 'Kota', 'Sumatera Utara'),
    city('Binjai', 'Kota', 'Sumatera Utara'),
    city('Pematangsiantar', 'Kota', 'Sumatera Utara'),
    city('Deli Serdang', 'Kabupaten', 'Sumatera Utara'),
    city('Asahan', 'Kabupaten', 'Sumatera Utara'),
    city('Karo', 'Kabupaten', 'Sumatera Utara'),
    city('Simalungun', 'Kabupaten', 'Sumatera Utara'),
    city('Padang', 'Kota', 'Sumatera Barat'),
    city('Bukittinggi', 'Kota', 'Sumatera Barat'),
    city('Payakumbuh', 'Kota', 'Sumatera Barat'),
    city('Pariaman', 'Kota', 'Sumatera Barat'),
    city('Agam', 'Kabupaten', 'Sumatera Barat'),
    city('Tanah Datar', 'Kabupaten', 'Sumatera Barat'),
    city('Pekanbaru', 'Kota', 'Riau'),
    city('Dumai', 'Kota', 'Riau'),
    city('Batam', 'Kota', 'Kepulauan Riau'),
    city('Tanjungpinang', 'Kota', 'Kepulauan Riau'),
    city('Kampar', 'Kabupaten', 'Riau'),
    city('Bengkalis', 'Kabupaten', 'Riau'),
    city('Palembang', 'Kota', 'Sumatera Selatan'),
    city('Lubuklinggau', 'Kota', 'Sumatera Selatan'),
    city('Prabumulih', 'Kota', 'Sumatera Selatan'),
    city('Ogan Komering Ilir', 'Kabupaten', 'Sumatera Selatan'),
    city('Bandar Lampung', 'Kota', 'Lampung'),
    city('Metro', 'Kota', 'Lampung'),
    city('Lampung Selatan', 'Kabupaten', 'Lampung'),
    city('Lampung Tengah', 'Kabupaten', 'Lampung'),
    city('Pontianak', 'Kota', 'Kalimantan Barat'),
    city('Singkawang', 'Kota', 'Kalimantan Barat'),
    city('Banjarmasin', 'Kota', 'Kalimantan Selatan'),
    city('Banjarbaru', 'Kota', 'Kalimantan Selatan'),
    city('Balikpapan', 'Kota', 'Kalimantan Timur'),
    city('Samarinda', 'Kota', 'Kalimantan Timur'),
    city('Bontang', 'Kota', 'Kalimantan Timur'),
    city('Palangka Raya', 'Kota', 'Kalimantan Tengah'),
    city('Tarakan', 'Kota', 'Kalimantan Utara'),
    city('Makassar', 'Kota', 'Sulawesi Selatan'),
    city('Parepare', 'Kota', 'Sulawesi Selatan'),
    city('Palopo', 'Kota', 'Sulawesi Selatan'),
    city('Gowa', 'Kabupaten', 'Sulawesi Selatan'),
    city('Maros', 'Kabupaten', 'Sulawesi Selatan'),
    city('Manado', 'Kota', 'Sulawesi Utara'),
    city('Kotamobagu', 'Kota', 'Sulawesi Utara'),
    city('Palu', 'Kota', 'Sulawesi Tengah'),
    city('Kendari', 'Kota', 'Sulawesi Tenggara'),
    city('Gorontalo', 'Kota', 'Gorontalo'),
    city('Denpasar', 'Kota', 'Bali'),
    city('Badung', 'Kabupaten', 'Bali'),
    city('Gianyar', 'Kabupaten', 'Bali'),
    city('Mataram', 'Kota', 'Nusa Tenggara Barat'),
    city('Bima', 'Kota', 'Nusa Tenggara Barat'),
    city('Lombok Barat', 'Kabupaten', 'Nusa Tenggara Barat'),
    city('Kupang', 'Kota', 'Nusa Tenggara Timur'),
    city('Ambon', 'Kota', 'Maluku'),
    city('Ternate', 'Kota', 'Maluku Utara'),
    city('Jayapura', 'Kota', 'Papua'),
    city('Sorong', 'Kota', 'Papua Barat Daya'),
];
export function searchIndonesianCities(query, maxResults = 8) {
    const normalizedQuery = query.trim().toLocaleLowerCase('id-ID');
    if (!normalizedQuery)
        return INDONESIAN_CITIES.slice(0, maxResults);
    return INDONESIAN_CITIES.filter(({ name, type, province }) => name.toLocaleLowerCase('id-ID').includes(normalizedQuery) ||
        province.toLocaleLowerCase('id-ID').includes(normalizedQuery) ||
        `${type} ${name}`.toLocaleLowerCase('id-ID').includes(normalizedQuery)).slice(0, maxResults);
}
